import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <Logo className="mb-3" />
            <p className="text-gray-600 text-xs leading-relaxed mb-3">
              Innovative IT Sales and Network Solution Services. Enterprise networks, cloud
              solutions, endpoint protection, and comprehensive IT support.
            </p>
            <div className="flex gap-2">
              <a
                href="mailto:info@rtechnos.com"
                className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-blue-100 hover:text-blue-600 transition-all duration-300"
              >
                <Mail size={16} />
              </a>
              <a
                href="tel:+917989109423"
                className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-blue-100 hover:text-blue-600 transition-all duration-300"
              >
                <Phone size={16} />
              </a>
              <a
                href="#"
                className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-blue-100 hover:text-blue-600 transition-all duration-300"
              >
                <MapPin size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-2 text-sm">Quick Links</h3>
            <ul className="space-y-1">
              <li>
                <Link to="/services" className="text-gray-600 hover:text-blue-600 transition-colors text-xs">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-600 hover:text-blue-600 transition-colors text-xs">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-gray-600 hover:text-blue-600 transition-colors text-xs">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors text-xs">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-2 text-sm">Services</h3>
            <ul className="space-y-1">
              <li className="text-gray-600 text-xs">IT Consulting</li>
              <li className="text-gray-600 text-xs">Cloud Solutions</li>
              <li className="text-gray-600 text-xs">Network Infrastructure</li>
              <li className="text-gray-600 text-xs">Security Solutions</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-2 text-sm">Contact</h3>
            <ul className="space-y-1 text-xs">
              <li className="text-gray-600">info@rtechnos.com</li>
              <li className="text-gray-600">+91 79891 09423</li>
              <li className="text-gray-600">Business Hours: Mon-Fri 9AM - 6PM</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-4 flex flex-col md:flex-row justify-between items-center text-xs">
          <p className="text-gray-500 mb-2 md:mb-0">
            © 2025 R-Technos. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-gray-500">
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
